import styles from './Product.module.css';
import arrows from './assets/arrows.svg';
import selected from './assets/selected.svg';

export default function Product({ focus, product, size, onSelect, cartAction, isActive, isInCart }) {
    return (
        <li
            className={`${styles.product} ${isActive ? styles.active+' selectedProduct' : ''}`}
            data-id={product.id}
            onClick={() => {
                onSelect(product.id);
            }}
        >
            <div className={styles.imgWrapper}>
                <img
                    loading="lazy"
                    src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${product.id}&type=prod&extra=(focus=${focus})&Size=${size}`}
                    alt={`Product - ${product.id}`}
                />
                <div className={styles.title}>
                    <span>{product.name}</span>
                </div>
             
                <div className={styles.cart}
                    onClick={(e) => {
                        e.stopPropagation();
                        cartAction(product);
                    }}
                >
                    {isInCart ? (
                        <span><span className={styles.icon}>&#45;</span> In samples</span>
                    ) : (
                        <span><span className={styles.icon}>&#43;</span> Add to samples</span>
                    )}
                </div>
                <hr />
                
                <div className={styles.activeContent}>
                    <img src={selected} className={styles.selectedImg} width="96" height="69" />
                </div>
            </div>
            <div className={styles.productInfo}>
                <div className={styles.title}>{product.color}</div>
             
                <div className={styles.description}>Species: {product.defaultRoomSceneSpecifier}</div>
                <div className={styles.baseDescription}>
                    <div className={styles.description}><img src={arrows} alt="arrows icon" height="11" width="auto"/> {product.thumbnailRenderOptions}</div>
                    <div className={styles.description}>{product.ecoFriendly}</div>
                </div>
            </div>
        </li>
    );
}
